var H = Object.defineProperty, v = Object.defineProperties;
var y = Object.getOwnPropertyDescriptors;
var u = Object.getOwnPropertySymbols;
var G = Object.prototype.hasOwnProperty, N = Object.prototype.propertyIsEnumerable;
var x = (d, r, n) => r in d ? H(d, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : d[r] = n, a = (d, r) => {
  for (var n in r || (r = {}))
    G.call(r, n) && x(d, n, r[n]);
  if (u)
    for (var n of u(r))
      N.call(r, n) && x(d, n, r[n]);
  return d;
}, o = (d, r) => v(d, y(r));
import { jsx as e, jsxs as h } from "react/jsx-runtime";
import { Fragment as j } from "react";
import { ExpandLess as A, ExpandMore as B } from "@material-ui/icons";
import { TableContainer as C, Table as L, TableHead as S, TableRow as c, TableCell as p, TableBody as q, ApiLoadingSpinner as w, ApiRequestError as M, TableFooter as O } from "@funcional/react-ui";
function K({
  tableInstance: d,
  status: r,
  isFetching: n,
  error: g,
  className: b,
  renderSubComponent: t,
  // compact,
  footer: P
}) {
  let s = 0;
  const {
    getTableProps: f,
    getTableBodyProps: R,
    headerGroups: E,
    footerGroups: m,
    rows: T,
    prepareRow: F
  } = d;
  return /* @__PURE__ */ e("div", { className: b, children: /* @__PURE__ */ e(C, { children: /* @__PURE__ */ h(L, o(a({}, f()), { children: [
    /* @__PURE__ */ e(S, { children: E.map((l) => /* @__PURE__ */ h(c, o(a({}, l.getHeaderGroupProps()), { children: [
      t ? /* @__PURE__ */ e(p, { children: " " }) : null,
      l.headers.map((i) => (s++, /* @__PURE__ */ h(p, o(a({}, i.getHeaderProps()), { children: [
        /* @__PURE__ */ e("div", { className: "whitespace-nowrap", children: i.render("Header") }),
        i.Filter ? /* @__PURE__ */ e("div", { className: "mt-2", children: i.render("Filter") }) : null
      ] }))))
    ] }))) }),
    /* @__PURE__ */ h(q, o(a({}, R()), { children: [
      r === "loading" || n ? /* @__PURE__ */ e(c, { children: /* @__PURE__ */ e(p, { colSpan: s, children: /* @__PURE__ */ e(w, {}) }) }) : null,
      g ? /* @__PURE__ */ e(c, { children: /* @__PURE__ */ e(p, { colSpan: s, children: /* @__PURE__ */ e(M, { error: g }) }) }) : null,
      T.length === 0 && !(r === "loading" || n) ? /* @__PURE__ */ e(c, { children: /* @__PURE__ */ e(p, { colSpan: s, children: "Não há nenhum registro para ser exibido." }) }) : null,
      T.map((l) => (F(l), /* @__PURE__ */ h(j, { children: [
        /* @__PURE__ */ h(c, o(a({}, l.getRowProps()), { children: [
          t ? /* @__PURE__ */ e(p, { style: { width: "2em" }, children: /* @__PURE__ */ e("span", o(a({}, l.getToggleRowExpandedProps()), { children: l.isExpanded ? /* @__PURE__ */ e(A, {}) : /* @__PURE__ */ e(B, {}) })) }) : null,
          l.cells.map((i) => /* @__PURE__ */ e(p, o(a({}, i.getCellProps()), { children: i.render("Cell") })))
        ] })),
        t && l.isExpanded ? /* @__PURE__ */ h(c, { children: [
          /* @__PURE__ */ e(p, { children: " " }),
          /* @__PURE__ */ e(p, { colSpan: s, children: t(l) })
        ] }) : null
      ] }, l.index)))
    ] })),
    m && P ? /* @__PURE__ */ e(O, { children: m.map((l) => /* @__PURE__ */ e(c, o(a({}, l.getFooterGroupProps()), { children: l.headers.map((i) => /* @__PURE__ */ e(p, o(a({}, i.getFooterProps()), { children: i.render("Footer") }))) }))) }) : null
  ] })) }) });
}
export {
  K as R
};
